import {addLabwareToFavorite, fetchFavoriteLabware, removeLabwareFromFavorite} from '../../api/userPreferenceApi';
import {ServiceResponseCode} from '../../constants/dataEnum';
import {setFavoriteLabwareIDs} from '../actions/userPreferenceStateAction';

export const addAndUpdateFavoriteLabware = (labwareID) => async (dispatch, getState) => {
  if (!labwareID) return;

  const {sessionState, userPreferenceState} = getState();
  const {user} = sessionState;
  const {favoriteLabwareIDs} = userPreferenceState;

  const response = await addLabwareToFavorite(user.userId, labwareID);

  if (response.serviceResponseCode === ServiceResponseCode.OK) {
    dispatch(setFavoriteLabwareIDs([labwareID, ...favoriteLabwareIDs]));
  }
};

export const removeAndUpdateFavoriteLabware = (labwareID) => async (dispatch, getState) => {
  if (!labwareID) return;

  const {sessionState, userPreferenceState} = getState();
  const {user} = sessionState;
  const {favoriteLabwareIDs} = userPreferenceState;

  const response = await removeLabwareFromFavorite(user.userId, labwareID);

  if (response.serviceResponseCode === ServiceResponseCode.OK) {
    dispatch(setFavoriteLabwareIDs(favoriteLabwareIDs.filter((ids) => ids !== labwareID)));
  }
};

export const fetchAndUpdateFavoriteLabwareIDs = () => async (dispatch, getState) => {
  const {sessionState} = getState();
  const {user} = sessionState;

  const favoriteLabwareIDs = await fetchFavoriteLabware(user.userId);
  dispatch(setFavoriteLabwareIDs(favoriteLabwareIDs));
};
